import React from 'react';

export default function CodesparkLogo({ alt = 'codeSpark', className}) {
    const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

    return <img src={`${imgURL}/global/logo/codespark-by-begin.png`} alt={alt} className={className} />
}
